import * as React from 'react';
import '@swc/helpers';
import '@grandvisionhq/utils';
import { usePaymentsUIContext } from '../../../../../context/PaymentsUI/context.js';
import '@paypal/react-paypal-js';
import '@grandvisionhq/state';
import { GooglePay } from './GooglePay.js';

const GooglePayRegularContainer = ()=>{
    const { cartTotalPrice , lineItems , setGooglePayToken  } = usePaymentsUIContext();
    return /*#__PURE__*/ React.createElement(GooglePay, {
        cartTotalPrice: cartTotalPrice,
        lineItems: lineItems,
        setGooglePayToken: setGooglePayToken
    });
};

export { GooglePayRegularContainer };
//# sourceMappingURL=GooglePayRegularContainer.js.map
